import script from "./WechselOption.vue?vue&type=script&setup=true&lang=js"
export * from "./WechselOption.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__